var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"container mx-auto py-4"},[_c('iframe',{staticClass:"w-full h-screen",attrs:{"src":_vm.detail.link,"title":"Tripwe"}})]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }